import { startRefreshAccessTokenAtRegularInterval } from '@auth/api/auth';
import { safeLocalStorageSetItem } from '@global/helpers/general';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: { [key: string]: string | number } = {};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout() {
      return {};
    },
    login: {
      reducer: (state, action: PayloadAction<Record<string, string | number>>) => {
        return { ...state, ...action.payload };
      },
      prepare: (data: Record<string, any>) => {
        if (Object.keys(data)?.length > 0) {
          Object.keys(data).forEach((key) => {
            if (!['startRefresh'].includes(key)) {
              safeLocalStorageSetItem(key, `${data[key]}`);
            }
          });
        }

        if (data?.startRefresh === true) {
          if (window.intervalId) {
            clearInterval(window.intervalId);
            window.intervalId = 0;
          }
          startRefreshAccessTokenAtRegularInterval();
        }
        return { payload: data };
      }
    }
  }
});

const { actions, reducer } = authSlice;
export const { login, logout } = actions;
export default reducer;
